import { atomWithStorage } from 'jotai/utils';

export const RIGHT_SIDEBAR_MIN_WIDTH = 320;
export const RIGHT_SIDEBAR_MAX_WIDTH = 640;
export const RIGHT_SIDEBAR_DEFAULT_WIDTH = 400;

export const rightSidebarWidthAtom = atomWithStorage<number>(
  'opal-right-sidebar-width',
  RIGHT_SIDEBAR_DEFAULT_WIDTH
);
